import _ from 'lodash'
import SearchIcon from 'mdi-react/SearchIcon'
import React, { PureComponent } from 'react'

import { InputAdornment, TextField } from '@mui/material'

export class DebouncedTextFilter extends PureComponent<DebouncedTextFilterProps> {
  constructor(props: DebouncedTextFilterProps) {
    super(props)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.propagateChange = _.debounce(this.propagateChange.bind(this), 250)
  }

  handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.propagateChange(event.target.value)
  }

  // We need to encapsulate the change, since event.target doesn't play well with debouncing
  propagateChange(search: string) {
    const { onChange } = this.props
    onChange(search)
  }

  render() {
    const { className, placeholder, defaultValue } = this.props
    return (
      <TextField
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={this.handleSearchChange}
        className={className}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    )
  }
}

export type DebouncedTextFilterProps = {
  className?: string
  placeholder: string
  defaultValue?: string
  onChange: (data: string) => void
}
